import { combineReducers } from 'redux';
import invite from './invite';

export const teamInviteReducers = combineReducers({ invite });
